import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/participants.action'
import { getCourses } from 'api/administration/participant/Get'

async function getParticipantCoursesById(id: number) {
  return await getCourses(id)
}

function* participantGetCoursesEffectSaga(action: any) {
  try {
    const data = yield call(getParticipantCoursesById, Number(action.payload))
    if (data) yield put(fromActions.Actions.participantGetCoursesSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* participantGetCoursesWatcherSaga() {
  yield takeLatest(fromActions.PARTICIPANTS_GET_COURSES, participantGetCoursesEffectSaga)
}
